import React from 'react';
import styled from 'styled-components';

const ProgressBar = ({ total, current }) => {
  const Wrapper = styled.div`
    display: flex;
    align-items: center;
    margin: 20px;
    .container {
      height: 5px;
      flex: 1;
      background-color: #e0e0de;
      border-radius: 50px;
      margin-right: 16px;
      .filler {
        height: 100%;
        background-color: #ed9b88;
        border-radius: inherit;
      }
    }
    .indicator {
      font-weight: 700;
      letter-spacing: normal;
      width: 45px;
      text-align: right;
      font-size: 14px;
    }
  `;
  const fillerStyle = {
    width: (current / total) * 100 + '%',
    transition: 'width 1s ease-in-out',
  };
  return (
    <Wrapper>
      <div className="container">
        <div className="filler" style={fillerStyle} />
      </div>
      <span className="indicator mont navy">
        {current} / {total}
      </span>
    </Wrapper>
  );
};

export default ProgressBar;
